import PropTypes from 'prop-types';
import React from 'react';

import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';
import { Section, SectionInner, ImageContainer, ContentContainer, Title, Text } from './InspirationOverview.style';

/**
 * 「クリエーション」トップ画面 > ページ最上部の「INSPIRATION」部分
 */
const InspirationOverview = ({ title, description, heroImage }) => (
  <Section>
    <SectionInner>
      <ImageContainer>
        {heroImage ? (
          <Image src={heroImage} options={{ size: [550, 850, 800], w: '100%' }} />
        ) : (
          <Placeholder w="100%" pb="83.33%" />
        )}
      </ImageContainer>

      <ContentContainer>
        <Title>{title || <Placeholder w="80%" pb="12%" />}</Title>
        <Text>{description || <Placeholder w="100%" pb="24%" />}</Text>
      </ContentContainer>
    </SectionInner>
  </Section>
);

InspirationOverview.defaultProps = {
  title: undefined,
  description: undefined,
  heroImage: undefined,
};

InspirationOverview.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  heroImage: PropTypes.shape(),
};

export default InspirationOverview;



// WEBPACK FOOTER //
// ./src/pages/InspirationPage/InspirationOverview/InspirationOverview.js